import { Fragment } from "react";
import { Icon, Table, Td, Th, Tr } from "@usas/ui-web/components/table/Table";
import { SORT_TYPES } from "@usas/ui-web/components/table/utils/TableConstants";
import useTableData from '@usas/ui-web/state/table/UseTableData';

import useSelectionsAdminToolGrid from "./UseSelectionsAdminToolGrid";
import ActionIntraPageButton from "@usas/ui-web/components/buttons/ActionIntraPageButton";

const TableTopRow = ({ dataTotal, isLoading, onAddClicked }) => {
  const { tableState } = useTableData();

  return (
    <Tr.Top colSpan={8} showDataTotal={isLoading !== true} dataName='Athletes' dataTotal={dataTotal}>
      <ActionIntraPageButton onClick={(e) => onAddClicked(e, tableState.selectedIds)}>Confirm Selected Champions {tableState.selectedIds.length > 0 ? `(${tableState.selectedIds.length})` : ''}</ActionIntraPageButton>
    </Tr.Top>
  );
}

const SelectionsAdminToolGrid = ({ data, isLoading, onSubmitFormCallback, onClearStatusClicked }) => {
  const {
    gridState,
    onAddSelectedClicked
  } = useSelectionsAdminToolGrid(data, onSubmitFormCallback);

  return (
    <Fragment>
      <Table.ContextWrapper data={gridState.gridData} rowIdKey={'ncaaConferenceChampionsId'} >
        <Table.Large>
          <thead>
            <TableTopRow dataTotal={gridState.gridData.length} isLoading={isLoading} onAddClicked={onAddSelectedClicked} />
            <tr>
              <Th.Input><Icon.SelectAll /></Th.Input>
              <Th.Sort sortKey={'lastName'} sortType={SORT_TYPES.ALPHABETICAL}>Name</Th.Sort>
              <Th.Sort sortKey={'meetName'} sortType={SORT_TYPES.ALPHABETICAL}>Meet</Th.Sort>
              <Th.Sort sortKey={'eventCode'} sortType={SORT_TYPES.ALPHABETICAL}>Event</Th.Sort>
              <Th.Sort sortKey={'swimTime'} sortType={SORT_TYPES.ALPHABETICAL}>Swim Time</Th.Sort>
              <Th.Sort sortKey={'typeName'} sortType={SORT_TYPES.ALPHABETICAL}>Gender</Th.Sort>
              <Th.Sort sortKey={'confirmedAutoBid'} sortType={SORT_TYPES.NUMERICAL}>Confirmed?</Th.Sort>
              <Th.Action></Th.Action>
            </tr>
          </thead>
          <Table.Body colSpan={7} isLoading={isLoading} noDataText='No NCAA Conference Champions Found'
            renderRow={(champions, i) =>
              <tr key={i}>
                <Td.Input>
                  {champions.confirmedAutoBid === false &&
                  <Icon.Select rowId={champions.ncaaConferenceChampionsId} />
                  }
                </Td.Input>
                <td style={{width: 250}}>{champions.lastName}, {champions.firstName}</td>
                <td style={{width: 300}}>{champions.meetName}</td>
                <td>{champions.eventCode}</td>
                <td>{champions.swimTime}</td>
                <td>{champions.typeName}</td>
                <td>{champions.confirmedAutoBid ? 'Yes' : 'No'}</td>
                <Td.Action>
                  {champions.confirmedAutoBid === true &&
                  <Icon.Undo onClick={(e) => onClearStatusClicked(e, champions.ncaaConferenceChampionsId)} />
                  }
                </Td.Action>
              </tr>
            } />
        </Table.Large>
        <Table.Small>
          <thead>
            <TableTopRow dataTotal={gridState.gridData.length} isLoading={isLoading} onAddClicked={onAddSelectedClicked} />
            <tr>
              <Th.Input><Icon.SelectAll /></Th.Input>
              <Th.Sort sortKey={'lastName'} sortType={SORT_TYPES.ALPHABETICAL}>Name</Th.Sort>
              <Th.Sort sortKey={'meetName'} sortType={SORT_TYPES.ALPHABETICAL}>Meet</Th.Sort>
              <Th.Sort sortKey={'eventCode'} sortType={SORT_TYPES.ALPHABETICAL}>Event</Th.Sort>
              <Th.Sort sortKey={'swimTime'} sortType={SORT_TYPES.ALPHABETICAL}>Swim Time</Th.Sort>
              <Th.Sort sortKey={'typeName'} sortType={SORT_TYPES.ALPHABETICAL}>Gender</Th.Sort>
              <Th.Sort sortKey={'confirmedAutoBid'} sortType={SORT_TYPES.NUMERICAL}>Confirmed?</Th.Sort>
              <Th.Action></Th.Action>
            </tr>
          </thead>
          <Table.Body colSpan={7} isLoading={isLoading} noDataText='No NCAA Conference Champions Found'
            renderRow={(champions, i) =>
              <tr key={i}>
                <Td.Input>
                  {champions.confirmedAutoBid === false &&
                  <Icon.Select rowId={champions.ncaaConferenceChampionsId} />
                  }
                </Td.Input>
                <td style={{width: 250}}>{champions.lastName}, {champions.firstName}</td>
                <td style={{width: 300}}>{champions.meetName}</td>
                <td>{champions.eventCode}</td>
                <td>{champions.swimTime}</td>
                <td>{champions.typeName}</td>
                <td>{champions.confirmedAutoBid ? 'Yes' : 'No'}</td>
                <Td.Action>
                  {champions.confirmedAutoBid === true &&
                  <Icon.Undo onClick={(e) => onClearStatusClicked(e, champions.ncaaConferenceChampionsId)} />
                  }
                </Td.Action>
              </tr>
            } />
        </Table.Small>
      </Table.ContextWrapper>
    </Fragment>
  );
};

export default SelectionsAdminToolGrid;